import smoothScrolling from './src/components/smoothScrolling';
import convertSVGinline from './src/helpers/inlineSvgConverter';

// Slider config
const swiperConfig = {
	slidesPerView: 1,
	slidesPerGroup: 1,
	centeredSlides: true,
	spaceBetween: 0,
	loop: true,
	grabCursor: true,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	a11y: {
		prevSlideMessage: 'Previous slide',
		nextSlideMessage: 'Next slide',
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		992: {
			slidesPerView: 2,
			slidesPerGroup: 1,
			centeredSlides: false,
		},
	},
};

async function home() {
	// Dynamic import
	const { default: swiperSlider } = await import('./src/components/swiper');

	// Functions:

	// Testemunhos Slider
	swiperSlider('.testemunhos-slider', swiperConfig);

	// Configuration adjustments for hero slider
	swiperConfig.effect = 'fade';
	swiperConfig.fadeEffect = { crossFade: true };
	swiperConfig.slidesPerView = 1;
	swiperConfig.autoplay = true;
	swiperConfig.speed = 1000;
	swiperConfig.grabCursor = false;
	swiperConfig.allowTouchMove = false;
	delete swiperConfig.slidesPerGroup;
	delete swiperConfig.breakpoints;
	delete swiperConfig.navigation;
	delete swiperConfig.pagination;
	swiperSlider('.home-hero-slider', swiperConfig);
}

async function profissionais() {
	// Dynamic import
	const { default: swiperSlider } = await import('./src/components/swiper');

	swiperSlider('.testemunhos-slider', swiperConfig);

	/*
	const { default: observerIntersect } = await import(
		'./src/helpers/observerIntersect'
	);

	const callback = (entries, observer) => {
		const bookingBtn = document.querySelector('.book-appointment');
		entries.forEach((entry, i) => {
			if (entry.isIntersecting) {
				bookingBtn.classList.add('hide');
			} else {
				bookingBtn.classList.remove('hide');
			}
		});
	};
	const agendaEl = document.querySelectorAll('.agenda');
	observerIntersect(agendaEl, callback);
	*/
}

async function servicos() {
	// Dynamic import
	const { default: accordion } = await import('./src/components/accordion');
	const { default: swiperSlider } = await import('./src/components/swiper');

	swiperSlider('.testemunhos-slider', swiperConfig);
	accordion('.faq-accordion');
}

function initDOMLoaded() {
	smoothScrolling();
	convertSVGinline();
	document.body.classList.contains('home') && home();
	document.body.classList.contains('prof-tpl') && profissionais();
	document.body.classList.contains('serv-tpl') && servicos();

	document.removeEventListener('DOMContentLoaded', initDOMLoaded);
}

// Code runs after page loaded
document.addEventListener('DOMContentLoaded', initDOMLoaded);
